export interface UserDirectoryDTO {
    userId?: string;
    userEmail?: string;
    userFullName?: string;
    userStatus?: string;
    userStatusLabel?: string;
    userType?: string;
    userRoleNames?: string;
    userContextNames?: string;
    userActiveProfileNames?: string;
    userPendingProfileNames?: string;
    userPendingEmailValidationRoleNames?: string;
    UserDeniedProfileNames?: string;
    userScopeValues?: string;
    userScopeType?: string;
    userScopeDisplayValues?: string;
    userLastUpdatedDt?: Date;
    userRoleExpireDt?: Date;
    b2cAccountActivationDt?: Date;
    userIdbApps?: string;
    userIsReadOnly?: string;
    userIsApprover?: string;
    requestId?: string;
    requestDt?: Date;
    canEdit?: boolean;
}
